<template>
  <div class="animated fadeIn">
    <faqdetails v-if="isfaq"></faqdetails>
  </div>
</template>
<script>
import faqdetails from "@/components/MasterSetup/FAQ/FAQDetails.vue";
export default {
  name: "Faq",
  components: {
    faqdetails,
  },
  data() {
    return {
      isfaq: true,
    };
  },
};
</script>
